import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple approaches to ensure scroll to top works on mobile
    
    // Method 1: Immediate scroll
    window.scrollTo(0, 0);
    
    // Method 2: Use requestAnimationFrame for better mobile compatibility
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    
    // Method 3: Slight delay for mobile browsers that need more time
    setTimeout(() => {
      window.scrollTo(0, 0);
      // Also try scrolling the document element and body
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    // Method 4: Additional fallback with longer delay
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 100);
    
  }, [pathname]);

  return null;
}

export default ScrollToTop;